import React from "react";
import { Helmet } from "react-helmet-async";
import { site, IMG } from "../data/site";

const DEFAULT_IMAGE = IMG.heroKitchen;

export const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  jsonLd,
  noindex = false,
}) => {
  const fullTitle = title
    ? `${title} | ${site.name}`
    : `${site.name} | Granite & Quartz Countertops`;
  const canonical = `${site.url}${path === "/" ? "" : path}`;
  const jsonLdArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={site.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLdArray.map((obj, i) => (
        <script type="application/ld+json" key={`${obj["@type"] || "ld"}-${i}`}>
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
};

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${site.url}${it.path === "/" ? "" : it.path}`,
  })),
});

export const businessLd = {
  "@context": "https://schema.org",
  "@type": "HomeAndConstructionBusiness",
  name: site.name,
  url: site.url,
  telephone: site.phone,
  email: site.email,
  image: DEFAULT_IMAGE,
  description:
    "Professional granite, quartz and stone fabrication and installation for residential and commercial projects in the Dallas–Fort Worth metroplex.",
  areaServed: site.serviceCities.map((c) => ({ "@type": "City", name: `${c}, TX` })),
  slogan: site.tagline,
};

export const websiteLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: site.name,
  url: site.url,
};

export const organizationLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: site.name,
  url: site.url,
  logo: site.logoLight,
  email: site.email,
  contactPoint: {
    "@type": "ContactPoint",
    telephone: site.phone,
    contactType: "sales",
    areaServed: "US-TX",
  },
};

export default Seo;
